var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _line, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _line2, _path19, _path20, _path21, _path22, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7, _tspan8, _tspan9, _tspan0, _tspan1, _tspan10, _tspan11, _path32, _circle, _circle2, _circle3, _rect3, _rect4, _rect5, _circle4, _circle5, _circle6, _circle7, _tspan12, _tspan13, _tspan14, _tspan15, _tspan16, _tspan17, _tspan18, _tspan19, _tspan20, _tspan21, _tspan22, _tspan23, _tspan24, _tspan25, _tspan26, _tspan27, _tspan28;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShunt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1475,
    height: 657,
    viewBox: "0 0 1475 657",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1475,
    height: 657,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shunt"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1475,
    height: 657,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 218",
    d: "M231.5 492H298.5L318.5 478.5",
    stroke: "black",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 222",
    d: "M231.5 570H298.5L318.5 556.5",
    stroke: "black",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 219",
    d: "M330.5 492H397.5H493",
    stroke: "black",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 221",
    d: "M330.5 571H397.5H493",
    stroke: "black",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 220",
    d: "M516.5 492H736.5V570.5H516.5",
    stroke: "black",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 213",
    d: "M332 214.5L347.5 238V309H494",
    stroke: "black",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 214",
    d: "M330 263L338.5 271V357H493.5",
    stroke: "black",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 215",
    d: "M446.5 357L438 349V181L446.5 166L467 143",
    stroke: "black",
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 216",
    d: "M430.5 308.5L421 302.5L422.5 149.5L446.5 117.5L467 96",
    stroke: "black",
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line 154",
    x1: 238,
    y1: 117.5,
    x2: 300,
    y2: 117.5,
    stroke: "black",
    strokeWidth: 3
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Line 160",
    d: "M467 165.5H494",
    stroke: "black",
    strokeWidth: 3
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Line 161",
    d: "M467 117.5H494",
    stroke: "black",
    strokeWidth: 3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Line 168",
    d: "M667 118H739",
    stroke: "black",
    strokeWidth: 3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Line 169",
    d: "M665 166H699",
    stroke: "black",
    strokeWidth: 3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 217",
    d: "M839.5 271.5H685V186L738.73 118.464C748.313 106.419 766.4 105.812 776.769 117.186L839.5 186V271.5Z",
    stroke: "black",
    strokeWidth: 3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Line 162",
    d: "M517 117.5H648.5L668.5 103",
    stroke: "black",
    strokeWidth: 3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Line 163",
    d: "M517 165.5H648.5L668.5 151",
    stroke: "black",
    strokeWidth: 3
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Line 164",
    d: "M517 213.5H648.5H686.5",
    stroke: "black",
    strokeWidth: 3
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Line 165",
    d: "M517 261.5H648.5H686.5",
    stroke: "black",
    strokeWidth: 3
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Line 166",
    d: "M517 309.5H780V272",
    stroke: "black",
    strokeWidth: 3
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Line 167",
    d: "M517 357.5H816V272",
    stroke: "black",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line 155",
    x1: 238,
    y1: 165.5,
    x2: 300,
    y2: 165.5,
    stroke: "black",
    strokeWidth: 3
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Line 156",
    d: "M324 165.5H447",
    stroke: "black",
    strokeWidth: 3
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Line 157",
    d: "M324 117.5H447",
    stroke: "black",
    strokeWidth: 3
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Line 158",
    d: "M318.5 102L299 117.5L281.5 141.5V213.5H493",
    stroke: "black",
    strokeWidth: 3
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Line 159",
    d: "M318.5 149.5L264.5 196.5V261.5H493",
    stroke: "black",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 146"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 179"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 493.5,
    y: 111.5,
    width: 23,
    height: 11,
    rx: 4.5,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.5,
    y: 111.5,
    width: 23,
    height: 11,
    rx: 4.5,
    stroke: "black",
    strokeOpacity: 0.2
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 199",
    cx: 499,
    cy: 117,
    r: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 200",
    cx: 511,
    cy: 117,
    r: 2,
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group 147"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 179_2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 493.5,
    y: 160.5,
    width: 23,
    height: 11,
    rx: 4.5,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.5,
    y: 160.5,
    width: 23,
    height: 11,
    rx: 4.5,
    stroke: "black",
    strokeOpacity: 0.2
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 199_2",
    cx: 499,
    cy: 166,
    r: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 200_2",
    cx: 511,
    cy: 166,
    r: 2,
    fill: "black"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group 148"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 179_3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 493.5,
    y: 207.5,
    width: 23,
    height: 11,
    rx: 4.5,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.5,
    y: 207.5,
    width: 23,
    height: 11,
    rx: 4.5,
    stroke: "black",
    strokeOpacity: 0.2
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 199_3",
    cx: 499,
    cy: 213,
    r: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 200_3",
    cx: 511,
    cy: 213,
    r: 2,
    fill: "black"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group 149"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 179_4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 493.5,
    y: 256.5,
    width: 23,
    height: 11,
    rx: 4.5,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.5,
    y: 256.5,
    width: 23,
    height: 11,
    rx: 4.5,
    stroke: "black",
    strokeOpacity: 0.2
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 199_4",
    cx: 499,
    cy: 262,
    r: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 200_4",
    cx: 511,
    cy: 262,
    r: 2,
    fill: "black"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group 150"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 179_5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 493.5,
    y: 303.5,
    width: 23,
    height: 11,
    rx: 4.5,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.5,
    y: 303.5,
    width: 23,
    height: 11,
    rx: 4.5,
    stroke: "black",
    strokeOpacity: 0.2
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 199_5",
    cx: 499,
    cy: 309,
    r: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 200_5",
    cx: 511,
    cy: 309,
    r: 2,
    fill: "black"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group 151"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 179_6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 493.5,
    y: 351.5,
    width: 23,
    height: 11,
    rx: 4.5,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.5,
    y: 351.5,
    width: 23,
    height: 11,
    rx: 4.5,
    stroke: "black",
    strokeOpacity: 0.2
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 199_6",
    cx: 499,
    cy: 357,
    r: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 200_6",
    cx: 511,
    cy: 357,
    r: 2,
    fill: "black"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group 152"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 179_7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 493.5,
    y: 486.5,
    width: 23,
    height: 11,
    rx: 4.5,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.5,
    y: 486.5,
    width: 23,
    height: 11,
    rx: 4.5,
    stroke: "black",
    strokeOpacity: 0.2
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 199_7",
    cx: 499,
    cy: 492,
    r: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 200_7",
    cx: 511,
    cy: 492,
    r: 2,
    fill: "black"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group 153"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 179_8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 493.5,
    y: 564.5,
    width: 23,
    height: 11,
    rx: 4.5,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.5,
    y: 564.5,
    width: 23,
    height: 11,
    rx: 4.5,
    stroke: "black",
    strokeOpacity: 0.2
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 199_8",
    cx: 499,
    cy: 570,
    r: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 200_8",
    cx: 511,
    cy: 570,
    r: 2,
    fill: "black"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 223",
    d: "M462 268.5L466 262.5L470.5 268.5",
    stroke: "black",
    strokeWidth: 3
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 224",
    d: "M462 221.5L466 215.5L470.5 221.5",
    stroke: "black",
    strokeWidth: 3
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 225",
    d: "M310 221.5L314 215.5L318.5 221.5",
    stroke: "black",
    strokeWidth: 3
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 227",
    d: "M333 110L337.235 116L342 110",
    stroke: "black",
    strokeWidth: 3
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 228",
    d: "M333 158L337.235 164L342 158",
    stroke: "black",
    strokeWidth: 3
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 229",
    d: "M471 158L475.235 164L480 158",
    stroke: "black",
    strokeWidth: 3
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 230",
    d: "M471 109L475.235 115L480 109",
    stroke: "black",
    strokeWidth: 3
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 231",
    d: "M337 483L341.235 489L346 483",
    stroke: "black",
    strokeWidth: 3
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 232",
    d: "M337 562L341.235 568L346 562",
    stroke: "black",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("text", {
    id: "HR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 321,
    y: 100.864
  }, "HR"))), /*#__PURE__*/React.createElement("text", {
    id: "110V",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 205,
    y: 142.864
  }, "110V"))), /*#__PURE__*/React.createElement("text", {
    id: "HR_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 321,
    y: 149.864
  }, "HR"))), /*#__PURE__*/React.createElement("text", {
    id: "HR_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 301,
    y: 208.864
  }, "HR"))), /*#__PURE__*/React.createElement("text", {
    id: "HR_4",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 301,
    y: 257.864
  }, "HR"))), /*#__PURE__*/React.createElement("text", {
    id: "HR_5",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 320,
    y: 474.864
  }, "HR"))), /*#__PURE__*/React.createElement("text", {
    id: "HR_6",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 320,
    y: 551.864
  }, "HR"))), /*#__PURE__*/React.createElement("text", {
    id: "HR_7",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 457,
    y: 257.864
  }, "HR"))), /*#__PURE__*/React.createElement("text", {
    id: "HR_8",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 457,
    y: 208.864
  }, "HR"))), /*#__PURE__*/React.createElement("text", {
    id: "HR_9",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan0 || (_tspan0 = /*#__PURE__*/React.createElement("tspan", {
    x: 470,
    y: 146.864
  }, "HR"))), /*#__PURE__*/React.createElement("text", {
    id: "HR_10",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan1 || (_tspan1 = /*#__PURE__*/React.createElement("tspan", {
    x: 470,
    y: 95.8636
  }, "HR"))), /*#__PURE__*/React.createElement("text", {
    id: "HR_11",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 676,
    y: 105.864
  }, "HR"))), /*#__PURE__*/React.createElement("text", {
    id: "HR_12",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 676,
    y: 146.864
  }, "HR"))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 226",
    d: "M310 269.5L314 263.5L318.5 269.5",
    stroke: "black",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "SH_OFF",
    cx: 760,
    cy: 155,
    r: 24.5,
    fill: "#D9D9D9",
    stroke: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "SH_ON",
    cx: 721,
    cy: 236,
    r: 24.5,
    fill: "#D9D9D9",
    stroke: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "SH_PILOT",
    cx: 799,
    cy: 236,
    r: 24.5,
    fill: "#D9D9D9",
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 180",
    x: 140.5,
    y: 40.5,
    width: 786,
    height: 365,
    rx: 9.5,
    stroke: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 181",
    x: 144.5,
    y: 455.5,
    width: 774,
    height: 137,
    rx: 9.5,
    stroke: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 182",
    x: 961.5,
    y: 40.5,
    width: 296,
    height: 552,
    rx: 9.5,
    stroke: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 199_9",
    cx: 240,
    cy: 117,
    r: 4,
    fill: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 204",
    cx: 240,
    cy: 165,
    r: 4,
    fill: "black"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 205",
    cx: 234,
    cy: 492,
    r: 4,
    fill: "black"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 206",
    cx: 234,
    cy: 570,
    r: 4,
    fill: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "HPR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 562,
    y: 510.864
  }, "HPR"))), /*#__PURE__*/React.createElement("text", {
    id: "V-ON=",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    x: 993,
    y: 195.273
  }, "V-ON="))), /*#__PURE__*/React.createElement("text", {
    id: "I-ON=",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    x: 993,
    y: 233.273
  }, "I-ON="))), /*#__PURE__*/React.createElement("text", {
    id: "V-OFF=",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    x: 993,
    y: 292.273
  }, "V-OFF="))), /*#__PURE__*/React.createElement("text", {
    id: "I-OFF=",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    x: 993,
    y: 323.273
  }, "I-OFF="))), /*#__PURE__*/React.createElement("text", {
    id: "V-Pilot=",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    x: 993,
    y: 394.273
  }, "V-Pilot="))), /*#__PURE__*/React.createElement("text", {
    id: "I-Pilot=",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    x: 993,
    y: 430.273
  }, "I-Pilot="))), /*#__PURE__*/React.createElement("text", {
    id: "HPR=",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    x: 993,
    y: 487.273
  }, "HPR="))), /*#__PURE__*/React.createElement("text", {
    id: "GEAR_NAME",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    x: 1042,
    y: 78.2727
  }, "......................."))), /*#__PURE__*/React.createElement("text", {
    id: "VON",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    x: 1080,
    y: 195.273
  }, "..................."))), /*#__PURE__*/React.createElement("text", {
    id: "ION",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan22 || (_tspan22 = /*#__PURE__*/React.createElement("tspan", {
    x: 1080,
    y: 233.273
  }, "..................."))), /*#__PURE__*/React.createElement("text", {
    id: "VOFF",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan23 || (_tspan23 = /*#__PURE__*/React.createElement("tspan", {
    x: 1080,
    y: 291.273
  }, "..................."))), /*#__PURE__*/React.createElement("text", {
    id: "IOFF",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan24 || (_tspan24 = /*#__PURE__*/React.createElement("tspan", {
    x: 1080,
    y: 323.273
  }, "..................."))), /*#__PURE__*/React.createElement("text", {
    id: "V_PILOT",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan25 || (_tspan25 = /*#__PURE__*/React.createElement("tspan", {
    x: 1080,
    y: 394.273
  }, "..................."))), /*#__PURE__*/React.createElement("text", {
    id: "I-PILOT",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan26 || (_tspan26 = /*#__PURE__*/React.createElement("tspan", {
    x: 1080,
    y: 430.273
  }, "..................."))), /*#__PURE__*/React.createElement("text", {
    id: "HPR_VOLTAGE",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan27 || (_tspan27 = /*#__PURE__*/React.createElement("tspan", {
    x: 1080,
    y: 487.273
  }, "..................."))), /*#__PURE__*/React.createElement("text", {
    id: "DATE",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan28 || (_tspan28 = /*#__PURE__*/React.createElement("tspan", {
    x: 749,
    y: 87.2727
  }, "........................")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShunt);
export default __webpack_public_path__ + "static/media/Shunt.e2fc8e6b668f18347427f84184ea482c.svg";
export { ForwardRef as ReactComponent };